import { Select, Spin } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ISelectOption } from "../../models/utils/selectOption";
import { defaultFilterOption } from "../../utils";
import { getCookie } from "typescript-cookie";
import { useLazyGetAnimalTypeListQuery } from "../../redux/api/handBooksApi/animalTypesApi";
import { EntTypeAnimalFilter } from "../../models/filters/TypeAnimalFilter";
import { useGetDataOnScroll } from "../getDataOnScrollProps/useGetDataOnScrollProps";
import { EntTypeAnimal } from "../../models/handBooks/typeAnimal";

interface IProps {
  onChange?: (value: number) => void;
  value?: number;
}

const SelectAnimalType = (props: IProps) => {
  const { t } = useTranslation();
  const [options, setOptions] = useState<ISelectOption[]>([]);

  const [getData] = useLazyGetAnimalTypeListQuery();
  const {
    fetching,
    data,
    setData,
    setFetching,
    setFilter,
    scrollHandler,
    setCurrentPage
  } = useGetDataOnScroll<EntTypeAnimal, EntTypeAnimalFilter>({
    initialFilter: new EntTypeAnimalFilter(),
    query: getData
  });

  useEffect(() => {
    const options = Array.from(new Set(data)).map((a) => {
      return { label: getCookie('i18next') === 'ky' ? `${a.nameKy}` : `${a.nameRu}` , value: a.id ?? '' };
    });
    setOptions(options);
  }, [data]);

  const search = (value?: string) => {
    if (!value) return;
    const filter = new EntTypeAnimalFilter();
    filter.name = value;
    setFilter(filter);
    setData([]);
    setCurrentPage(0);
    setFetching(true);
  }
  const clear = () => {
    const filter = new EntTypeAnimalFilter();
    filter.name = null;
    setFilter(filter);
    setData([]);
    setCurrentPage(0);
    setFetching(true);
  }

  return (
    <Select
      placeholder={t("msg.selectPlaceholder")}
      onClear={clear}
      onSearch={search}
      onPopupScroll={scrollHandler}
      loading={fetching}
      value={props.value}
      onChange={props.onChange}
      options={options}
      filterOption={defaultFilterOption}
      showSearch
      allowClear
      dropdownRender={(menu) => (
          <Spin spinning={fetching}>
            {menu}
          </Spin>
      )}
    />
  );
};

export default SelectAnimalType;